import { useThunkReducer } from '@shared/hooks/useThunkReducer';
import { selectPhoneAttributes } from '@shared/reducers/user';
import React from 'react';
import { useSelector as useReduxSelector } from 'react-redux';
import { FlowStep } from '../../components/FlowStep';
import { StepSmartPhoneInput } from './components/StepSmartPhoneInput';
import { StepSmartPhoneSelect } from './components/StepSmartPhoneSelect';
import {
  init,
  selectCurrentStep,
  selectLabel,
  selectMessage,
  stepSmartPhoneReducer,
} from './reducers/stepSmartPhoneReducer';

export const StepSmartPhone = (props) => {
  const phoneAttributes = useReduxSelector(selectPhoneAttributes);
  const initializerArg = {
    data: props.data,
    phoneAttributes: phoneAttributes,
  };
  const [state, dispatch, useSelector] = useThunkReducer(stepSmartPhoneReducer, {
    devToolsName: props.devToolsName,
    initializerArg: initializerArg,
    initializer: init,
  });

  const currentStep = useSelector(selectCurrentStep);
  const label = useSelector((state) => selectLabel(state, props.config));
  const message = useSelector((state) => selectMessage(state, props.config, props.data));

  return (
    <FlowStep label={label} message={message}>
      {React.createElement(getStepBy(currentStep), {
        state: state,
        dispatch: dispatch,
        useSelector: useSelector,
        required: props.config.required,
        onComplete: props.completeStep,
      })}
    </FlowStep>
  );
};
const stepBy = {
  input: StepSmartPhoneInput,
  select: StepSmartPhoneSelect,
};

const getStepBy = (currentStep) => stepBy[currentStep] ?? stepBy.input;
